var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"customer_service_icon"},[_c('div',{staticClass:"coze_btn_text",on:{"click":_vm.openCoze}},[_c('i',{staticClass:"iconfont-v3 saasline-robot"}),_c('span',[_vm._v("AI助手")])]),_c('div',{attrs:{"id":"coze_btn"}},[_vm._v("微吼-售后AI助手")])])
}
var staticRenderFns = []

export { render, staticRenderFns }